import React, { useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { userContext } from "../../../Contexts/userContext";
import { MoonLoader } from "react-spinners";
import SessionCard from "../../../Components/Molecules/Cards/SessionCard/SessionCard";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import ClassIcon from "@mui/icons-material/Class";
import AddIcon from "@mui/icons-material/Add";
import EventIcon from "@mui/icons-material/Event";
import PersonIcon from "@mui/icons-material/Person";
import SchoolIcon from "@mui/icons-material/School";
import BusinessIcon from "@mui/icons-material/Business";
import VisibilityIcon from "@mui/icons-material/Visibility";
import dayjs from "dayjs";

function ClassSessions({
  Class,
  sessions,
  loading,
  sessionsOpen,
  setSessionsOpen,
  url,
  setSessions,
}) {
  const { contextData } = useContext(userContext);
  const navigate = useNavigate();
  const { id } = useParams();

  if (loading) {
    return (
      <div className="mainContainer">
        <div className="loadingContainer">
          <MoonLoader color="#012369" size={40} />
        </div>
      </div>
    );
  }

  return (
    <div className="mainContainer">
      {/* Class Header */}
      <div className="contentSection">
        <div className="courseHeader">
          <div className="titleIcon">
            <ClassIcon />
          </div>
          <div className="courseBasicInfo">
            <h1 className="courseName">{Class?.className} Sessions</h1>
          </div>
          <div className="courseStats">
            <div
              className="statItem clickable"
              onClick={() => {
                const element = document.getElementById("sessions");
                element?.scrollIntoView({ behavior: "smooth" });
              }}
            >
              <EventIcon className="statIcon" />
              <span className="statLabel">Sessions</span>
              <span className="statValue">{sessions?.length || 0}</span>
            </div>
            <div
              className="statItem"
              onClick={() => {
                const element = document.getElementById("class-details");
                element?.scrollIntoView({ behavior: "smooth" });
              }}
            >
              <ClassIcon className="statIcon" />
              <span className="statLabel">Status</span>
              <span className="statValue">
                {Class?.isTerminated ? "Terminated" : "Active"}
              </span>
            </div>
          </div>
        </div>

        <h2 className="sectionTitle">Class Details</h2>
        <div className="infoGrid">
          <div
            className="infoItem clickable"
            onClick={() => navigate(`/programs/${Class?.course?.id}`)}
          >
            <div className="infoLabel">
              <SchoolIcon className="infoIcon" />
              Program
            </div>
            <div className="infoValue">
              {Class?.course?.title || "No program assigned"}
            </div>
          </div>
          <div
            className="infoItem clickable"
            onClick={() => navigate(`/schools/${Class?.school?.id}`)}
          >
            <div className="infoLabel">
              <BusinessIcon className="infoIcon" />
              School
            </div>
            <div className="infoValue">
              {Class?.school?.name || "No school assigned"}
            </div>
          </div>
          <div
            className="infoItem clickable"
            onClick={() => navigate(`/instructors/${Class?.teacher?.id}`)}
          >
            <div className="infoLabel">
              <PersonIcon className="infoIcon" />
              Instructor
            </div>
            <div className="infoValue">
              {Class?.teacher?.name || "No instructor assigned"}
            </div>
          </div>
        </div>
      </div>

      {/* Sessions Section */}
      <div className="contentSection" id="sessions">
        <div className="lessonsHeader">
          <h2 className="sectionTitle">Sessions</h2>
          {!Class?.isTerminated && (
            <button
              className="actionButton primary"
              onClick={() => navigate(`/classes/${id}/sessions/add`)}
            >
              <AddIcon />
              Add Session
            </button>
          )}
        </div>

        {sessions?.length ? (
          <div className="lessonsGrid">
            {sessions?.map((session, index) => (
              <div key={index} className="lessonCard">
                <div className="lessonHeader">
                  <div className="lessonIcon">
                    <EventIcon />
                  </div>
                  <div className="lessonInfo">
                    <h4 className="lessonTitle">{session?.title}</h4>
                    <p className="lessonSession">{session?.lesson?.title}</p>
                  </div>
                </div>

                <div className="lessonContent">
                  <p className="lessonSession" style={{ marginBottom: "5px" }}>
                    Date: {dayjs(session?.dateTime).format("DD/MM/YYYY")}
                  </p>
                  <p className="lessonDescription">
                    {session.content && session.content.length > 100
                      ? `${session.content.substring(0, 100)}...`
                      : session.content || "No content available"}
                  </p>
                </div>

                <div className="lessonFooter">
                  <button
                    className="viewLessonButton"
                    onClick={() =>
                      navigate(`/classes/${id}/sessions/${session.id}`)
                    }
                    title="View session details"
                  >
                    <VisibilityIcon />
                    View Details
                  </button>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="emptyState">
            <EventIcon className="emptyIcon" />
            <h3>No Sessions Yet</h3>
            <p>Start by adding your first session to this class</p>
            {contextData?.role === "admin" && !Class?.isTerminated && (
              <button
                className="actionButton primary"
                onClick={() => navigate(`/classes/${id}/sessions/add`)}
                style={{ margin: "20px auto" }}
              >
                <AddIcon />
                Add First Session
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default ClassSessions;
